import React from "react";
import Contact from "../../Components/ContactUs/ContactUs.js";
import Footer from "../../Components/Footer/Footer.js";

function MarketPlace() {
    return (
        <>
            <Contact />
            <Footer />
        </>
    );
}
export default MarketPlace;
